define.alias("shared/modifiers/animate-typewriter", "media/modifiers/animate-typewriter");